  import {useState, useRef, useMemo} from 'react'
import useToggle from "../../shared/functions/useToggle";
import useFamily from "../../hooks/useFamily";

import {
    Stack,
    Typography,
    TextField,
    Paper,
    IconButton,
    ButtonGroup,
    Button,
    Collapse,
    Skeleton,
    Grid
} from '@mui/material'
import FamilyCreateForm from "./FamilyCreateForm";
import {Delete, Edit, KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";
import DeletePopover from "../_customs/DeletePopover";
import {useDispatch} from "react-redux";
import {deleteFamily} from "../../redux/slices/family";
import {toast} from "react-toastify";
import {searchList} from "../../utils/array";

export default function Family() {

    const {list, loading} = useFamily()
    const [keyword, setKeyword] = useState('')
    const items = useMemo(() => {

        const formatted = list?.map(one => ({
            ...one,
            _helper: `${one?.label} ${one?.code} ${one?.desciption} `
        }))

        return searchList(formatted, keyword, '_helper')

    }, [list, keyword])

    const [selected, setSelected] = useState(null)
    const {handleClose, handleOpen, open} = useToggle()


    const handleEdit = (selected) => {
        setSelected(selected)
        handleOpen()
    }

    const handleClosing = () => {
        handleClose()
        setSelected(null)
    }

    return (
        <Stack spacing={3}>

            <Stack direction={'row'} justifyContent={'space-between'} spacing={2}>
                <Typography variant={'h5'}>
                    Famille
                </Typography>

                <Stack direction={'row'} spacing={2}>
                    <TextField
                        size={'small'}
                        label={'Rechercher...'}
                        sx={{width: 400}}
                        value={keyword}
                        onChange={event => setKeyword(event.target.value)}
                    />

                    <Button variant={'contained'} onClick={handleOpen}>
                        Ajouter
                    </Button>

                </Stack>

            </Stack>


            <Grid container spacing={1}>
                {
                    items?.map(one => (
                        <Grid item key={one?.id} md={4} sm={12} xs={12}>
                            <Item item={one} onEdit={handleEdit}/>
                        </Grid>
                    ))
                }
            </Grid>


            {
                loading && (
                    <Grid container spacing={1}>
                        {
                            [...Array(7)]?.map((one, key) => (
                                <Grid item key={key} md={4}>
                                    <Skeleton variant={'rectangular'} height={50} width={'100%'}/>
                                </Grid>
                            ))
                        }
                    </Grid>
                )
            }


            <FamilyCreateForm selected={selected} open={open} onClose={handleClosing}/>


        </Stack>
    )

}

const Item = ({item, onDelete, onEdit}) => {
    const ref = useRef()
    const dispatch = useDispatch();
    const {handleSwitch, open} = useToggle()
    const {handleOpen, handleClose, open: display} = useToggle()
    const [loading, setLoading] = useState(false)

    const handleDelete = () => {
        setLoading(true)
        dispatch(deleteFamily(item?.id, () => {
            toast.success('Supprime avec success')
            setLoading(false)
        }))
    }

    return (
        <Paper md={3} sx={{boxShadow: 5, p: 1,}}>
            <Stack>
                <Stack direction={'row'} justifyContent={'space-between'}>

                    <Stack spacing={2} justifyContent={'center'}>
                        <Typography variant={'subtitle1'}>
                            {item?.label}
                        </Typography>
                    </Stack>


                    <ButtonGroup>
                        <IconButton onClick={() => onEdit && onEdit(item)}>
                            <Edit/>
                        </IconButton>

                        <IconButton onClick={handleSwitch}>
                            {
                                open
                                    ? <KeyboardArrowUp/>
                                    : <KeyboardArrowDown/>
                            }
                        </IconButton>

                        <IconButton ref={ref} onClick={handleOpen}>
                            <Delete/>
                        </IconButton>
                    </ButtonGroup>


                </Stack>

                <Collapse in={open}>
                    <Stack spacing={2} sx={{mt: 4}}>
                        <Stack spacing={1}>
                            <Typography sx={{fontWeight: 'bold'}}>
                                Code:
                            </Typography>
                            <Typography>
                                {item?.code}
                            </Typography>
                        </Stack>

                        <Stack spacing={1}>
                            <Typography sx={{fontWeight: 'bold'}}>
                                Description:
                            </Typography>
                            <Typography>
                                {item?.Description.replace(/^"?(.+?)"?$/,'$1')}
                            </Typography>
                        </Stack>
                    </Stack>
                </Collapse>


            </Stack>
            <DeletePopover
                anchorRef={ref}
                onDelete={handleDelete}
                text={'ceswdet element'}
                onClose={handleClose}
                open={display}
                pending={loading}
            />
        </Paper>
    )
}
